const FETCH_MESSAGES = 'leads/publisherChat/FETCH_MESSAGES';
const FETCH_MESSAGES_SUCCEEDED = 'leads/publisherChat/FETCH_MESSAGES_SUCCEEDED';
const FETCH_MESSAGES_FAILED = 'leads/publisherChat/FETCH_MESSAGES_FAILED';

const CHANGE_TAB_OPTION = 'leads/publisherChat/CHANGE_TAB_OPTION';

const ADD_MESSAGE = 'leads/publisherChat/ADD_MESSAGE';
const ADD_MESSAGE_SUCCEEDED = 'leads/publisherChat/ADD_MESSAGE_SUCCEEDED';

const SET_TRANSLATION = 'leads/publisherChat/SET_TRANSLATION';

const ADD_FILE = 'leads/publisherChat/ADD_FILE';
const ADD_FILE_SUCCEEDED = 'leads/publisherChat/ADD_FILE_SUCCEEDED';
const REMOVE_FILE = 'leads/publisherChat/REMOVE_FILE';
const RESET_FILES = 'leads/publisherChat/RESET_FILE_SUCCEEDED';
const ERROR_UPLOAD = 'leads/publisherChat/ERROR_UPLOAD';
const SHOW_SNACKBAR = 'leads/publisherChat/SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'leads/publisherChat/HIDE_SNACKBAR';
const REVERT_ERROR = 'leads/publisherChat/REVERT_ERROR';

const SHOW_MODAL = 'leads/publisherChat/SHOW_MODAL';

export {
  SET_TRANSLATION,
  ADD_MESSAGE,
  ADD_MESSAGE_SUCCEEDED,
  CHANGE_TAB_OPTION,
  FETCH_MESSAGES,
  FETCH_MESSAGES_SUCCEEDED,
  FETCH_MESSAGES_FAILED,
  ADD_FILE,
  ADD_FILE_SUCCEEDED,
  REMOVE_FILE,
  RESET_FILES,
  ERROR_UPLOAD,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  REVERT_ERROR,
  SHOW_MODAL
};
